import React from 'react'
import ErrorFallback from '../Common/ErrorFallback'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Here we can send logs or catch components and re-render with error message
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback error={this.state.error}/>
    }

    return this.props.children
  }
}

export default ErrorBoundary
